import type { ModuleOptions } from '#cookie-control/types'

export default {
  "barPosition": "bottom-full",
  "closeModalOnClickOutside": false,
  "colors": {
    "barBackground": "#FFFFFF",
    "barButtonBackground": "#fff",
    "barButtonColor": "#000",
    "barButtonHoverBackground": "#333",
    "barButtonHoverColor": "#fff",
    "barTextColor": "#000000",
    "checkboxActiveBackground": "#000",
    "checkboxActiveCircleBackground": "#fff",
    "checkboxDisabledBackground": "#ddd",
    "checkboxDisabledCircleBackground": "#fff",
    "checkboxInactiveBackground": "#000",
    "checkboxInactiveCircleBackground": "#fff",
    "controlButtonBackground": "#fff",
    "controlButtonHoverBackground": "#000",
    "controlButtonIconColor": "#000",
    "controlButtonIconHoverColor": "#fff",
    "focusRingColor": "#808080",
    "modalBackground": "#fff",
    "modalButtonBackground": "#000",
    "modalButtonColor": "#fff",
    "modalButtonHoverBackground": "#333",
    "modalButtonHoverColor": "#fff",
    "modalOverlay": "#000",
    "modalOverlayOpacity": 0.8,
    "modalTextColor": "#000",
    "modalUnsavedColor": "#fff"
  },
  "cookies": {
    "necessary": [
      {
        "id": "translations",
        "name": {
          "en": "Translations",
          "pt": "Traduções",
          "es": "Traducciones",
          "fr": "Traductions"
        },
        "description": {
          "en": "Used to manage the language set on the website. Managed by miio. Validity: 7 days.",
          "pt": "Utilizado para gerir a língua definida no website. Gerido pela miio. Validade: 7 dias.",
          "es": "Utilizado para gestionar el idioma establecido en el sitio web. Administrado por miio. Validez: 7 días.",
          "fr": "Utilisé pour gérer la langue définie sur le site Web. Géré par miio. Validité: 7 jours."
        },
        "isPreselected": true
      },
      {
        "id": "firebase",
        "name": {
          "en": "Authentication",
          "pt": "Autenticação",
          "es": "Autenticación",
          "fr": "Authentification"
        },
        "description": {
          "en": "Used to allow user authentication on the website. Managed by Firebase. Validity: 2 weeks.",
          "pt": "Utilizado para permitir a autenticação dos utilizados no website. Gerido pelo Firebase. Validade: 2 semanas.",
          "es": "Utilizado para permitir la autenticación de los usuarios en el sitio web. Administrado por Firebase. Validez: 2 semanas.",
          "fr": "Utilisé pour permettre l'authentification des utilisateurs sur le site Web. Géré par Firebase. Validité: 2 semaines."
        },
        "isPreselected": true
      }
    ],
    "optional": [
      {
        "id": "ad_storage",
        "name": {
          "en": "Marketing",
          "pt": "Marketing",
          "es": "Marketing",
          "fr": "Marketing"
        },
        "description": {
          "en": "Marketing cookies help us provide personalized ads based on your preferences and interests, limit ad repetition, measure the effectiveness of our campaigns, and analyze email traffic. They also identify you on future visits, keeping your preferences and settings. This allows us to understand your buying patterns and provide a personalized experience. Managed by Google Tag Manager, Meta Pixel, and OneSignal. Validity: up to 1 year.",
          "pt": "Os cookies de marketing ajudam-nos a fornecer anúncios personalizados de acordo com as suas preferências e interesses, limitar a repetição de anúncios, medir a eficácia das nossas campanhas e analisar o tráfego de e-mails. Eles também identificam-no em visitas futuras, mantendo as suas preferências e configurações. Isto permite-nos entender os seus padrões de compra e proporcionar uma experiência personalizada. Gerido pelo Google Tag Manager, Meta Pixel e OneSignal. Validade: até 1 ano.",
          "es": "Los cookies de marketing nos ayudan a proporcionar anuncios personalizados según sus preferencias e intereses, limitar la repetición de anuncios, medir la eficacia de nuestras campañas y analizar el tráfico de correos electrónicos. También le identifican en futuras visitas, manteniendo sus preferencias y configuraciones. Esto nos permite entender sus patrones de compra y proporcionar una experiencia personalizada. Administrado por Google Tag Manager, Meta Pixel y OneSignal. Validez: hasta 1 año.",
          "fr": "Les cookies marketing nous aident à fournir des annonces personnalisées en fonction de vos préférences et intérêts, à limiter la répétition des annonces, à mesurer l'efficacité de nos campagnes et à analyser le trafic des e-mails. Ils vous identifient également lors de vos prochaines visites, en conservant vos préférences et paramètres. Cela nous permet de comprendre vos habitudes d'achat et de fournir une expérience personnalisée. Géré par Google Tag Manager, Meta Pixel et OneSignal. Validité: jusqu'à 1 an."
        },
        "isPreselected": false
      },
      {
        "id": "analytics_storage",
        "name": {
          "en": "Analytics",
          "pt": "Analytics",
          "es": "Analytics",
          "fr": "Analytics"
        },
        "description": {
          "en": "We use analytics cookies to obtain statistical data and improve user experience on our website. We collect information on traffic, visitor behavior, session recordings, heatmaps, and specific interactions. Managed by Google Tag Manager and Microsoft Clarity. Validity: up to 1 year.",
          "pt": "Utilizamos cookies de analytics para obter dados estatísticos e melhorar a experiência dos utilizadores no nosso website. Recolhemos informações sobre tráfego, comportamento dos visitantes, gravações de sessões, mapas de calor e interações específicas. Gerido pelo Google Tag Manager e pelo Microsoft Clarity. Validade: até 1 ano.",
          "es": "Utilizamos cookies de análisis para obtener datos estadísticos y mejorar la experiencia de los usuarios en nuestro sitio web. Recopilamos información sobre tráfico, comportamiento de los visitantes, grabaciones de sesiones, mapas de calor e interacciones específicas. Gestionado por Google Tag Manager y Microsoft Clarity. Validez: hasta 1 año.",
          "fr": "Nous utilisons des cookies d'analyse pour obtenir des données statistiques et améliorer l'expérience des utilisateurs sur notre site web. Nous recueillons des informations sur le trafic, le comportement des visiteurs, les enregistrements de sessions, les cartes de chaleur et les interactions spécifiques. Géré par Google Tag Manager et Microsoft Clarity. Validité : jusqu'à 1 an."
        },
        "isPreselected": false
      }
    ]
  },
  "cookieExpiryOffsetMs": 31536000000,
  "cookieNameIsConsentGiven": "cookie_consent",
  "cookieNameCookiesEnabledIds": "cookie_ids",
  "cookieOptions": {
    "path": "/",
    "sameSite": "strict",
    "secure": true
  },
  "isAcceptNecessaryButtonEnabled": false,
  "isControlButtonEnabled": false,
  "isCookieIdVisible": false,
  "isCssEnabled": true,
  "isCssPonyfillEnabled": false,
  "isDashInDescriptionEnabled": true,
  "isIframeBlocked": false,
  "isModalForced": false,
  "locales": [
    "en",
    "pt",
    "es",
    "fr",
    "en"
  ],
  "localeTexts": {
    "en": {
      "accept": "Accept",
      "acceptAll": "Accept all",
      "bannerDescription": "We use our own cookies and third-party cookies so that we can display this website correctly and better understand how this website is used, with a view to improving the services we offer. A decision on cookie usage permissions can be changed anytime using the cookie button that will appear after a selection has been made on this banner.",
      "bannerTitle": "Cookies",
      "close": "Close",
      "cookiesFunctional": "Functional cookies",
      "cookiesNecessary": "Necessary cookies",
      "cookiesOptional": "Optional cookies",
      "decline": "Decline",
      "declineAll": "Decline all",
      "here": "here",
      "iframeBlocked": "To see this, please enable functional cookies",
      "manageCookies": "Manage cookies",
      "save": "Save",
      "settingsUnsaved": "You have unsaved settings"
    },
    "pt": {
      "accept": "Aceitar",
      "acceptAll": "Aceitar todos",
      "bannerDescription": "Nós utilizamos os nossos próprios cookies e de terceiros para que possamos lhe mostrar este site e compreender a forma como o utiliza, de forma a melhorarmos os serviços que oferecemos. Ao continuar a navegar no site, consideramos que aceitou a utilização de cookies.",
      "bannerTitle": "Cookies",
      "close": "Fechar",
      "cookiesFunctional": "Cookies funcionais",
      "cookiesNecessary": "Cookies necessários",
      "cookiesOptional": "Cookies opcionais",
      "decline": "Recusar",
      "declineAll": "Recusar todos",
      "here": "aqui",
      "iframeBlocked": "Para visualizar isto, por favor, active os cookies funcionais",
      "manageCookies": "Gerir cookies",
      "save": "Guardar",
      "settingsUnsaved": "Tem alterações por guardar"
    },
    "es": {
      "accept": "Aceptar",
      "acceptAll": "Aceptar todo",
      "bannerDescription": "Utilizamos cookies propias y de terceros para poder mostrarle una página web y comprender cómo la utiliza, con el fin de mejorar los servicios que ofrecemos. Si continúa navegando, consideramos que acepta su uso.",
      "bannerTitle": "Cookies",
      "close": "Cerrar",
      "cookiesFunctional": "Cookies funcionales",
      "cookiesNecessary": "Cookies necesarias",
      "cookiesOptional": "Cookies opcionales",
      "decline": "Rechazar",
      "declineAll": "Rechazar todo",
      "here": "aquí",
      "iframeBlocked": "Para ver esto, por favor habilita las cookies funcionales.",
      "manageCookies": "Administrar cookies",
      "save": "Guardar",
      "settingsUnsaved": "Tiene cambios sin guardar"
    },
    "fr": {
      "accept": "Accepter",
      "acceptAll": "Tout accepter",
      "bannerDescription": "Nous utilisons des cookies d’origine et des cookies tiers. Ces cookies sont destinés à vous offrir une navigation optimisée sur ce site web et de nous donner un aperçu de son utilisation, en vue de l’amélioration des services que nous offrons. En poursuivant votre navigation, nous considérons que vous acceptez l’usage des cookies.",
      "bannerTitle": "Cookies",
      "close": "Fermer",
      "cookiesFunctional": "Cookies fonctionnels",
      "cookiesNecessary": "Cookies nécessaires",
      "cookiesOptional": "Cookies optionnels",
      "decline": "Refuser",
      "declineAll": "Tout refuser",
      "here": "ici",
      "iframeBlocked": "Pour voir cela, veuillez activer les cookies fonctionnels",
      "manageCookies": "Gérer les cookies",
      "save": "Sauvegarder",
      "settingsUnsaved": "Vous avez des modifications non enregistrées"
    }
  }
} as ModuleOptions